import React from 'react';
import PageHeader from '../components/layout/PageHeader';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
const Sitemap = () => {
  const sitemapSections = [{
    title: 'Main Pages',
    links: [{
      name: 'Home',
      path: '/'
    }, {
      name: 'About',
      path: '/about'
    }, {
      name: 'Campus',
      path: '/campus'
    }, {
      name: 'Academics',
      path: '/academics'
    }, {
      name: 'Admissions',
      path: '/admissions'
    }, {
      name: 'Student Life',
      path: '/student-life'
    }, {
      name: 'News',
      path: '/news'
    }, {
      name: 'Events',
      path: '/events'
    }, {
      name: 'Gallery',
      path: '/gallery'
    }, {
      name: 'PTA',
      path: '/pta'
    }, {
      name: 'Alumni',
      path: '/alumni'
    }, {
      name: 'Scholarships',
      path: '/scholarships'
    }, {
      name: 'Support',
      path: '/support'
    }, {
      name: 'Contact',
      path: '/contact'
    }]
  }, {
    title: 'About Us',
    links: [{
      name: 'History & Founding',
      path: '/about#history'
    }, {
      name: 'Vision & Mission',
      path: '/about#vision'
    }, {
      name: 'School Anthem',
      path: '/about#anthem'
    }, {
      name: 'School Badge & Motto',
      path: '/about#badge'
    }, {
      name: 'Leadership Team',
      path: '/about#leadership'
    }, {
      name: 'Isonyin Community',
      path: '/isonyin-community'
    }, {
      name: 'Emmanuel Church',
      path: '/emmanuel-church'
    }, {
      name: 'Islamic Religion',
      path: '/islamic-religion'
    }]
  }, {
    title: 'Campus',
    links: [{
      name: 'Virtual Tour',
      path: '/virtual-tour'
    }, {
      name: 'Facilities',
      path: '/campus#facilities'
    }]
  }, {
    title: 'Academics',
    links: [{
      name: 'Curriculum',
      path: '/academics#curriculum'
    }, {
      name: 'Performance Records',
      path: '/academics#performance'
    }, {
      name: 'Teaching Staff',
      path: '/academics#staff'
    }, {
      name: 'Academic Calendar',
      path: '/academics#calendar'
    }, {
      name: 'Clubs & Societies',
      path: '/academics#clubs'
    }]
  }, {
    title: 'Admissions',
    links: [{
      name: 'How to Apply',
      path: '/admissions#apply'
    }, {
      name: 'Requirements',
      path: '/admissions#requirements'
    }, {
      name: 'Forms',
      path: '/admissions#forms'
    }, {
      name: 'Fees',
      path: '/admissions#fees'
    }, {
      name: 'FAQs',
      path: '/admissions#faqs'
    }]
  }, {
    title: 'Student Life',
    links: [{
      name: 'Boarding House',
      path: '/student-life#boarding'
    }, {
      name: 'Sports',
      path: '/student-life#sports'
    }, {
      name: 'Events',
      path: '/student-life#events'
    }, {
      name: 'Testimonials',
      path: '/student-life#testimonials'
    }, {
      name: 'Clubs & Societies',
      path: '/student-life/clubs'
    }]
  }, {
    title: 'Alumni',
    links: [{
      name: 'Alumni Association',
      path: '/alumni#association'
    }, {
      name: 'Executive Committee',
      path: '/alumni/excos'
    }, {
      name: 'Sets Directory',
      path: '/alumni#directory'
    }, {
      name: 'Featured Alumni',
      path: '/alumni#featured'
    }, {
      name: 'Alumni Events',
      path: '/alumni/events'
    }, {
      name: 'Join Alumni Association',
      path: '/alumni/join'
    }]
  }, {
    title: 'Support',
    links: [{
      name: 'Ways to Give',
      path: '/support#donate'
    }, {
      name: 'Volunteer Opportunities',
      path: '/support#volunteer'
    }, {
      name: 'Corporate Partnerships',
      path: '/support/corporate-partnerships'
    }, {
      name: 'Alumni Support',
      path: '/support#alumni'
    }]
  }, {
    title: 'Legal',
    links: [{
      name: 'Privacy Policy',
      path: '/privacy-policy'
    }, {
      name: 'Terms of Use',
      path: '/terms-of-use'
    }]
  }];
  return <div className="min-h-screen bg-white" data-id="element-5234">
      <PageHeader title="Sitemap" description="A complete guide to all pages on the Isonyin Grammar School website." backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/guWk5XsDGYmXXcoEtCyUpd/WhatsApp_Image_2025-10-24_at_11.30.12_%281%29.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Sitemap',
      path: '/sitemap'
    }]} data-id="element-5235" />
      <div className="container mx-auto px-4 py-12" data-id="element-5236">
        <div className="text-center mb-10" data-id="element-5237">
          <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5238">
            Website Navigation
          </h2>
          <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5239"></div>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5240">
            Find all pages and sections of our website organized by category.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-5241">
          {sitemapSections.map((section, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-md" data-id="element-5242">
              <h3 className="text-xl font-bold text-blue-900 mb-4 border-b border-gray-200 pb-2" data-id="element-5243">
                {section.title}
              </h3>
              <ul className="space-y-2" data-id="element-5244">
                {section.links.map((link, linkIndex) => <li key={linkIndex} data-id="element-5245">
                    <Link to={link.path} className="flex items-center text-gray-700 hover:text-blue-700 transition-colors" data-id="element-5246">
                      <ChevronRightIcon className="h-4 w-4 mr-2 text-blue-700" data-id="element-5247" />
                      {link.name}
                    </Link>
                  </li>)}
              </ul>
            </div>)}
        </div>
        <div className="mt-16 bg-blue-50 p-8 rounded-lg border border-blue-100 text-center" data-id="element-5248">
          <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-5249">
            Can't Find What You're Looking For?
          </h3>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-5250">
            If you can't find the information you need, please don't hesitate to
            contact us. Our team is here to help you navigate our website and
            find the information you need.
          </p>
          <div className="flex justify-center" data-id="element-5251">
            <Link to="/contact" className="px-6 py-3 bg-blue-700 text-white font-medium rounded-md hover:bg-blue-600 transition-colors shadow-sm hover:shadow" data-id="element-5252">
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </div>;
};
export default Sitemap;